export default {
    // スクロール禁止
    no_scroll: function () {
        // マウスホイールを無効
        document.addEventListener("mousewheel", this.scrollControlMousewheel, { passive: false });
        // マウスホイールを無効(Firefox用)
        document.addEventListener("DOMMouseScroll", this.scrollControlMousewheel, { passive: false });
        // タッチ操作を無効(スマホ)
        // document.addEventListener("touchmove", this.scrollControlMousewheel, { passive: false });
        // 矢印キ－の上下の入力を無効
        document.addEventListener("keydown", this.scrollControlKeyboard, { passive: false });
        // スクロールバーを非表示
        document.body.style.overflow = "hidden";
    },
    // スクロール禁止解除
    return_scroll: function () {
        // マウスホイールを有効
        document.removeEventListener("mousewheel", this.scrollControlMousewheel, { passive: false });
        // マウスホイールを有効(Firefox用)
        document.removeEventListener("DOMMouseScroll", this.scrollControlMousewheel, { passive: false });
        // タッチ操作を有効(スマホ)
        // document.removeEventListener('touchmove', this.scrollControlMousewheel, { passive: false });
        // 矢印キ－の上下の入力を有効
        document.removeEventListener('keydown', this.scrollControlKeyboard, { passive: false });
        // スクロールバーを表示
        document.body.style.overflow = "auto";
    },
    // スクロール制御(マウス)
    scrollControlMousewheel: function (event) {
        event.preventDefault();
    },
    // スクロール制御(キーボード)
    scrollControlKeyboard: function (event) {
        // キーコード(どのキーが押されたか)を取得
        var keyCode = event.keyCode;
        // 矢印キーの上下の入力を無効
        if (keyCode == 38 || keyCode == 40 || keyCode == 9) {
            event.preventDefault();
        }
    },
}